export default {
    documentTypes: {
        acceptance: 'Acceptance Certificate',
        deliveryslip: 'Delivery Slip',
        invoice: 'Invoice',
        order: 'Order',
        orderconfirmation: 'Order Confirmation',
        orderslip: 'Order Slip',
        paymentnotice: 'Payment Notice',
        quote: 'Quote',
        receipt: 'Receipt',
        timesheet: 'Timesheet',
    },
};
